import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <h4 className="font-heading text-xl font-bold text-background-50 mb-4">
                制服诱惑
              </h4>
              <p className="text-sm text-background-400 leading-relaxed">
                探索制服诱惑的时尚魅力与文化内涵，从职业制服到影视造型，为你提供最全面的制服穿搭与角色扮演灵感。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
                制服分类
              </h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
                快速链接
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
                关注我们
              </h4>
              <div className="flex items-center gap-4">
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-accent-500 transition-colors"
                  aria-label="微信"
                  rel="nofollow"
                >
                  <i className="ri-wechat-line text-background-200"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-accent-500 transition-colors"
                  aria-label="微博"
                  rel="nofollow"
                >
                  <i className="ri-weibo-line text-background-200"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-accent-500 transition-colors"
                  aria-label="小红书"
                  rel="nofollow"
                >
                  <i className="ri-chat-smile-2-line text-background-200"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2026 制服诱惑 版权所有 | 保留所有权利
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">
                隐私政策
              </a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">
                服务条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}